import { Box, type BoxProps, styled, Typography } from "@mui/material";
import React from "react";

const StyledRoot = styled(Box)`
  background-color: ${(props) => props.theme.palette.orange.light};
  padding: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.palette.orange.contrastText};
`;

export const DocumentListDownloadHelper = ({ ...boxProps }: BoxProps) => {
  return (
    <StyledRoot {...boxProps}>
      <Typography>
        Si vous ne parvenez pas à télécharger vos documents, nous vous invitons à vérifier dans les
        paramètres de votre navigateur que l'ouverture des fenêtres n'est pas bloquée.
      </Typography>
    </StyledRoot>
  );
};
